module.exports = function anonymous(it
) {
var out='<!-- created by hezq on 2019-09-05 description： 头部模版--><div class="spzx_header clearfix bfff"><span class="spzx_logo fl"><img src="'+(it.dpath)+'$$_STATICPATH_$$/images/bqy_logo.png" alt=""></span>';if(it.user){out+='<div class="spzx_header_rmenu fr"><a href="javascript:;" class="spzx_header_user">';if(it.imgurl){out+='<img src="'+(it.imgurl)+'">';}else{out+='<img src="'+(it.dpath)+'$$_STATICPATH_$$/images/spzx_userdefault.png">';}out+='<span>'+(it.user.username)+'</span><ul><li class="loginOut">退出平台</li></ul></a></div>';}out+='</div>';return out;
}


//////////////////
// WEBPACK FOOTER
// ./src/template/dot/layout/header/module/header.dot
// module id = 173
// module chunks = 5